<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
         <div class="iscompanyQuit" v-if="form.auditStatus == 'wait'||form.auditStatus == 'processing'">
           <img
             src="../../../assets/images/new/blueInfo.png"
             alt=""
           />当月累计已申请事假和年假共计{{ leaveObj.monthLeaveTotal }}天，本年度事假审批通过共{{ leaveObj.yearPersonalLeaveTotal }}天 
         </div>
          <div class="totals-box plr24 mt20">
            <div class="flex-row mb30">
              <div class="itemName">店员姓名</div>
              <div class="itemNum">{{ form.staffName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">审核状态</div>
              <div class="itemNum jishi">{{ form.auditStatusCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">请假类型</div>
              <div class="itemNum">{{ form.leaveCateName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">开始时间</div>
              <div class="itemNum">{{formatDay(form.beginTime)}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">结束时间</div>
              <div class="itemNum">{{formatDay(form.endTime)}}</div>
            </div>
            
            <div class="flex-row mb30">
              <div class="itemName">请假天数</div>
              <div class="itemNum">{{form.leaveDayNum}}天</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">备注</div>
              <div class="itemNum huanxin">{{ form.leaveReason }}</div>
            </div>
          </div>

          <div v-if="form.auditStatus != 'cancel'">
            <p class="order-title-boxs"><span class="blueBlock"></span><i>审核流程</i></p>
            <div class="audit-boxs">
              <div v-for="(item,index) in form.flowAuditRecordList" :key="index" class="group-list">
                <div class="totals-box pl24 mt20">
                  <div class="flex-row mb30">
                    <div class="itemName">{{ item.flowNodeName?item.flowNodeName:'' }}</div>
                    <div :class="item.auditStatus == 'refuse'?'success':'wait'">{{ item.auditStatusCn }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">审核人</div>
                    <div>{{ item.auditOpName?item.auditOpName:'' }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">审核时间</div>
                    <div class="time">{{ item.auditTime?formatDate(item.auditTime):'' }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="drawer-footer">
          <div class="btns pr24 pb10" style="display: flex;align-items: center;" v-perm="{key:'attendancePunch', value: 'attendancePunch:leaveAudit'}">
            <el-button type="danger" v-if="form.refuseFlag" class="small-btn" @click="cancel('refuse')">拒绝</el-button>
            <el-button type="primary" v-if="form.agreeFlag" class="small-btn" @click="cancel('pass')">同意</el-button>
            <el-button type="warning" v-if="form.cancelFlag" class="small-btn" @click="cancel('cancel')">撤销</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: { drawer },
  data() {
    return {
      addEditTitle: "",
      addEditShow: false,
      optionName: [], // 请假人
      allStaffList: [], // 请假类型
      form: {
        id: "",
      },
      userInfo: {},
	    leaveObj: {
        monthLeaveTotal: 0,
        yearPersonalLeaveTotal: 0
      }
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.addEditShow = false;
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.userInfo = this.$store.getters.ShopInfo;
        this.$api.get(this.$url.companyLeave.get,{id: org.id}).then(res => {
          if (res) {
            this.form = res;
			      this.getStaffLeaveDay();
          }
        })
        this.addEditShow = true;
        this.addEditTitle = "请假详情";
      });
    },
    getStaffLeaveDay() {
      this.$api.get(this.$url.companyLeave.getLeaveDay,{staffId:this.form.staffId,leaveId:this.form.id, leaveTime: this.formatDay(this.form.beginTime)}).then(res => {
        if (res) {
          this.leaveObj = res;
        }
      })
    },
    handleChangeDrawer() {
      this.addEditShow = false;
    },
    cancel (value) {
      let msg;
        if (value == 'refuse') {
          msg = `确定要拒绝吗?`
        } else if (value == 'pass') {
          msg = `确定要同意吗?`
        } else {
           msg = `确定要撤销吗?`
        }
        const h = this.$createElement;
        this.$msgbox({
          title: '提示',
          message: h('p', null,[
            h('span', { style: 'color: red' }, msg)
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true
        }).then(action => {
          if (value == 'pass' || value == 'refuse') {
            this.$api.post(this.$url.companyLeave.audit, {id: this.form.id,auditStatus: value}).then(res => {
              if (res) {
                this.addEditShow = false;
                this.$message.success("操作成功");
                this.$emit("change", true);
              }
            }).catch(error => {});
          } else {
            this.$api.get(this.$url.companyLeave.cancel, {id: this.form.id}).then(res => {
              if (res) {
                this.addEditShow = false;
                this.$message.success("撤销成功");
                this.$emit("change", true);
              }
            }).catch(error => {});
          }
      });
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.toggle-text {
  padding: 0 20px;
}
.refund_box {
    background: #fff;
    padding: 10px 20px;
    
    .infos {
      color: #ff892a;
      padding-bottom: 10px;
    }
}
.leaveBox {
  background: #fff;
  padding: 10px 20px;
}
.member_bg {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ .el-dialog {
  margin-top: 20vh !important;
}
.pay-mains {
  padding: 0;

  .card-ruleForm {
    padding-bottom: 0;
    padding-top: 10px;
    /deep/ .el-form-item {
      border-bottom: 1px solid @borderColor;
      padding: 10px 20px;
      margin-bottom: 0;
      
    }
    .item-cards {
      background: #fff;
      padding: 20px;
      /deep/ .el-form-item__content {
        flex: 2;
        // text-align: right;
        // display: flex;
        margin-left: 0 !important;
        .el-form-item__error {
          right: 0;
        }
      }
    }
    .el-form-item-update {
      align-items: center;
      display: flex;
      margin: 0;
      // justify-content: space-between;
      border-bottom: 1px solid @borderColor;
      background: #fff;
      &:first-child {
        margin-top: 0;
      }
      /deep/ .el-form-item__label {
        font-size: 16px;
        font-weight: 500;
        // text-align: left;
      }
      /deep/ .el-form-item__content {
        flex: 2;
        text-align: right;
        // display: flex;

        margin-left: 0 !important;
        .el-form-item__error {
          z-index: 1;
          right: 0;
        }
      }

      /deep/ .el-input__inner {
        width: 200px;
          text-align: left;
        // text-align: right;
      }
      
      /deep/ .el-radio__inner {
        width: 22px;
        height: 22px;
      }
      /deep/ .el-radio__label {
        font-size: 16px;
      }

      /deep/ .el-input.is-disabled .el-input__inner {
        background: #fff;
      }
      /deep/ .el-link {
        width: 160px;
      }
    }
    .head-img {
    //   height: 90px;
        padding: 10px;
      background: #fff;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #dceaed;
      /deep/ .el-form-item__content {
        .top-img {
          width: 100%;
          border-radius: 50%;
          .text-upload {
            position: absolute;
            top: 20px;
            right: 0;
            line-height: initial;
          }
        }
        .el-link {
          width: auto;
          cursor: pointer;
        }
        .img {
          width: 60px;
          height: 60px;
        }
      }
    }
  }
  
}
.moneys {
    color: red !important;
}
</style>